export default "__VITE_ASSET__50505774__"